import { enviroment } from "../../enviroment";

// REACT_APP_DESIGN_ORDERABILITY_GUARD_ORG_IDS (19/10, Nichlas: «lad denne i
// første omgang kun være tilgængelig med en ejer, altså en vendor»): the
// order guard's UI (row / popup rule, bulk filter + skip toast, the readable
// 400 toast) for a LIST of organisation ids while the global flag
// REACT_APP_DESIGN_ORDERABILITY_GUARD_ENABLED stays false - the twin of the
// API's OrderDesignApprovalGuardEnforceOrgIds (enforce for the listed
// organisations, today's mode for everybody else). A listed id matches the
// viewer's own organisation OR its parent, so a customer under the listed
// dealer is covered too. Pure functions over the build-time list, 0 calls.
// Unset / empty list = the flag alone = byte-identical.

// Older suites mock `enviroment` as a partial object without the list;
// read it defensively so a missing field means "nobody listed".
function listedOrgIds(): readonly number[] {
  const ids: unknown = enviroment.designOrderabilityGuardOrgIds;
  return Array.isArray(ids) ? (ids as number[]) : [];
}

/**
 * The guard's UI for THIS viewer: the global flag, or the viewer's
 * organisation / its parent in the list. Consumers with a React context
 * read it through useOrderabilityGuardActive.
 */
export function isOrderabilityGuardActiveFor(
  orgId: number | null | undefined,
  parentId: number | null | undefined,
): boolean {
  if (enviroment.designOrderabilityGuardEnabled) return true;
  const ids = listedOrgIds();
  if (ids.length === 0) return false;
  return (
    (orgId != null && ids.includes(orgId)) ||
    (parentId != null && ids.includes(parentId))
  );
}

/**
 * The gate for the two readers without a React context (mapError's 400
 * marker, isNotApprovedOrderError): the flag, or a non-empty list. Safe
 * without knowing the viewer - the API sends the designNotApproved /
 * logoNotApproved 400 only where it enforces (= the listed organisations),
 * so every other organisation never carries the marker = today's toast.
 */
export function anyOrderabilityGuard(): boolean {
  return enviroment.designOrderabilityGuardEnabled || listedOrgIds().length > 0;
}
